import React from 'react';
import MainTitle from '../../components/page/main-title/MainTitle';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import TextInputWithUploader from '../../components/form/TextInputWithUploader';
import TextArea from "../../components/form/TextArea";
import SelectAjax from "../../components/form/SelectAjax";
import ItemSimplesListagem from '../../components/listagem/ItemSimplesListagem';
import STRINGS from './../../data/language/language';
import Random from "../../utils/strings/Random";
import {FormDataToJson} from '../../utils/json/Json';
import Dialog from '../../components/alert/Dialog';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import PAGES from '../../config/Pages';
const itemIdPrefix = "item-exercicio-";
const URL_SAVE = WS.exercicios.save;

class Page extends React.Component{
  constructor (props){
    super(props);

    this.state = {
      strings:STRINGS[window.LANGUAGE],
      detalhe: props.detalhe
    }
  }

  componentDidMount() {
  }

  componentWillUnmount() {

  }

  render (){
    let lista = this.state.detalhe.pagamentos.map((value, i) =>
      <div className='item-relatorio' key={i}>
          <div className='item-relatorio__title'>{value.data}</div>
          <div>Tipo: {value.tipo_adesao}</div>
          <div>Valor: {value.valor}</div>
      </div>
      );

    return (
      <div>
        <MainTitle title='Pagamentos' />
        {lista}
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/relatorios/Page.js